var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { LocaleAwareBaseComponent } from '../../common-theme';
import { AgencyService } from '../../common-theme/api';
var MenuContainerComponent = /** @class */ (function (_super) {
    __extends(MenuContainerComponent, _super);
    function MenuContainerComponent(agencyService, document) {
        var _this = _super.call(this) || this;
        _this.agencyService = agencyService;
        _this.document = document;
        _this.hasLogo = true;
        _this.hasSocialLinks = true;
        _this.hasPhoneNumber = false;
        return _this;
    }
    MenuContainerComponent.prototype.ngOnInit = function () {
        if (!this.links || this.links.length === 0) {
            throw new Error('MenuContainerBaseComponent Error: Invalid links');
        }
    };
    MenuContainerComponent.prototype.toggleMobileMenu = function () {
        this.open = !this.open;
        if (this.open) {
            this.document.body.classList.add('no-scroll');
        }
        else {
            this.document.body.classList.remove('no-scroll');
        }
    };
    return MenuContainerComponent;
}(LocaleAwareBaseComponent));
export { MenuContainerComponent };



// WEBPACK FOOTER //
// ./src/app/shared/menu-container/menu-container.component.ts.pre-build-optimizer.js